export default "__VITE_ASSET__Ci2Q0Y1p__"